import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable()
export class CloseModalService {
  leaveWithoutSaving$: Subject<boolean> = new Subject<boolean>();
}
